// extracted by mini-css-extract-plugin
var _1 = "cPvNb";
export { _1 as "filter" }
